import React, { useEffect, useRef, useState } from 'react'
import {
    ApiDTO_NTSPform,
    ApiDTO_NTSPUI_ElementList,
    initialFormState,
    NTSP_StatPortalProps,
    NTSPDevices,
    NTSPElement,
    setTimezone,
} from './Ntsp_Slice'
import { FoundationsButton } from '../../GenericComponents/button'
import { text } from 'stream/consumers'
import {
    formatDateInput,
    formatDateTimeLocal,
    formatTimeInput,
    tzCodeToIANA,
    IANAToTzCode,
} from '../../Utils'
import { set } from 'react-hook-form'
import { AcuteServiceKey, DarkModeColors, DEFAULT_LKW_TIME, getAge, getNowInFacilityTimezone, getServiceLineEnum, LightModeColors, SabacuteServiceKey, teleEEGServiceKey, validateForm,getReactSelectCustomStyles,Neurohospitalistkey, isConsultantRequired } from './NTSP_StatPortal'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import 'moment-timezone'
import DatePicker from '../../GenericComponents/DatePicker'
import InputMask from 'react-input-mask'
import Select, { components, GroupProps } from 'react-select'
import { PatientDetailsHeader } from './PatientHeader'
import { usePromiseDebounce } from '../../Hooks/usePromiseDebounce' //FP-12575 debounce to prevent multiple rapid clicks on save button
// import DatePicker from '../../GenericComponents/DatePicker'
declare let window: any
const UnicornApp = window.unicornInstance as any
export const getLocalTimeZone = () => {
    //after files are moved to master this should go in utils.tsx, but not now because it might get missed
    const date = new Date()
    const options = { timeZoneName: 'short' }
    const formatter = new Intl.DateTimeFormat('en-US', options as any)
    const parts = formatter.formatToParts(date)

    let timeZoneAbbreviation = ''
    for (const part of parts) {
        if (part.type === 'timeZoneName') {
            timeZoneAbbreviation = part.value
            break
        }
    }
    return timeZoneAbbreviation
}
export const getUserServiceLines= (NTSPElement: ApiDTO_NTSPUI_ElementList) => {
    const serviceLines: number[] = [];
    const userAttributes = UnicornApp.globals.me.get('UserAttributes') as any[] || [];
    const userServiceLinesAttr = userAttributes.find(attr => attr.MetaDataId ===  NTSPElement?.ConsultServiceMetadataId);

    if (userServiceLinesAttr && userServiceLinesAttr.KeyValues) {
        serviceLines.push(...userServiceLinesAttr.KeyValues);
    }   
    return serviceLines;
}

export const getUserFacilities= (LocationMetadataId: number) => {
    const facilities: number[] = [];
    const userAttributes = UnicornApp.globals.me.get('UserAttributes') as any[] || [];
    const availablefacilities = userAttributes.find(attr => attr.MetaDataId === LocationMetadataId);

    if (availablefacilities && availablefacilities.KeyValues) {
        facilities.push(...availablefacilities.KeyValues);
    }   
    return facilities;
}
const SymptomGroup = (
    props: GroupProps<
        {
            readonly value: string
            readonly label: string
            readonly color: string
            readonly isFixed?: boolean
            readonly isDisabled?: boolean
        },
        false
    >
) => {
    const groupStyles = {
        borderBottom: `2px solid inherit`,
    }
    return (
        <div style={groupStyles}>
            <components.Group {...props} />
        </div>
    )
}

const PatientDetails: React.FC<NTSP_StatPortalProps> = ({
    form,
    setForm,
    NTSPElements,
    handleSave,
    handleClear,
    newCase,
    validationSchema,
    errors,
    setErrors,
    isSaved,
    nurseNotes,
    isLoadingNTSPElements,
    selectedSymptoms,
    setSelectedSymptoms,
}) => {
    const dispatch = useDispatch()
    if (errors === undefined) errors = {}
    if (setErrors === undefined) setErrors = (errors: any) => {}
    if (validationSchema === undefined) validationSchema = {}
    const [submitted, setSubmitted] = useState<boolean>(false)
    const [saving, setSaving] = useState<boolean>(false)
    const [timezone, setTimezoneState] = useState<string>('')
    const [togglePatientDetails, setOpenPatientDetails] = useState(true)
    const [isNightMode, setIsNightMode] = useState(document.body.classList.contains('night-mode'))
    const [NewNote, setNewNote] = useState<string>('')
    const [isCustomerSite] = useState<boolean>(UnicornApp.checkUserPrivileges("NTSPCustomer"))
    const [LocationMetadataId]= useState<number>(UnicornApp.globals.appSettings.attributes.LocationMetadata || -1) 
    const debouncedHandleSave = usePromiseDebounce(async (...args: Parameters<typeof handleSave>) => {
        return await Promise.resolve(handleSave(...args));
    }); //FP-12575 debounce to prevent multiple rapid clicks

    if (!selectedSymptoms) {selectedSymptoms = {}}
    type FieldErrors = {
        [key: string]: string
    }
    if (!setSelectedSymptoms) {
        setSelectedSymptoms = () => {}
    }

    const firstInputRef = useRef(null as any)
    const lastInputRef = useRef(null as any)
    const formRef = useRef(null as any)
    const prevFormNewNoteRef = useRef<string | undefined>()
    const [remainigNotes, setRemainingNotes] = useState(2048)
    const [consultants, setConsultants] = useState<NTSPElement[]>()
    const [toggleSymptoms, setOpenSymptoms] = useState(true)
    const [toggleDisposition, setOpenDisposition] = useState(true)
    const [typeMap, setTypeMap] = useState<{
        [s: string]: { [s: string]: { label: string; value: string }[] }
    }>({})
    // const [selectedSymptoms, setSelectedSymptoms] = useState<{ label: string; value: string }[]>()
    // const [mappedSelected, setSelectedSymptoms] = useState<{
    //     [s: string]: { label: string; value: string }[]
    // }>({})

    const customStyles = getReactSelectCustomStyles(isNightMode)
    const getFacilityServiceSupport = (facilityKey: number) => { //FP-14539 Determine which services a facility supports based on its SiteStatus and other properties
        const facility = NTSPElements?.Facilities?.find((f: NTSPElement) => f._key === facilityKey)
        const siteStatus = (facility?.SiteStatus || '').toLowerCase()

        // Use word boundaries so "subacute" does not get treated as "acute".
        const supportsAcute = /\bacute\b/.test(siteStatus)
        const supportsSubacute = /\bsubacute\b/.test(siteStatus)

        return {
            supportsAcute,
            supportsSubacute,
            supportsTeleEEG: facility?.IsEEG === true,
            supportsNeurohospitalist: facility?.IsNeurohospitalist === true,
        }
    }

    const isServiceAllowedForFacility = (service: NTSPElement, facilityKey: number) => {
        const {
            supportsAcute,
            supportsSubacute,
            supportsTeleEEG,
            supportsNeurohospitalist,
        } = getFacilityServiceSupport(facilityKey)

        if (service._key === AcuteServiceKey) return supportsAcute
        if (service._key === SabacuteServiceKey) return supportsSubacute
        if (service._key === teleEEGServiceKey) return supportsTeleEEG
        if (service._key === Neurohospitalistkey) return supportsNeurohospitalist

        return false
    }

    useEffect(() => {
        let roles = new Set<string>()
        NTSPElements?.ServiceTitleMapping.forEach(service=>{
            const serviceLine = NTSPElements?.ConsultServices?.find(s=>s.FriendlyName === service.ServiceLine)?._key
            if (serviceLine === form.fk_ConsultService){
                roles.add(service.Title as string)
            } 
        })
        let filteredConsultants = NTSPElements?.Consultants?.filter((consultant) =>{
            return roles.has(consultant.StaffTitle as string)
        })
        setConsultants(filteredConsultants)
    }, [form.fk_ConsultService])

    const updateSelectedSymptoms = (newValue: any, type: string) => {
        setSelectedSymptoms((prev) => ({
            ...prev,
            [type]: newValue || [],
        }))
        // setSelectedSymptoms(Object.values({ ...mappedSelected, [type]: newValue || [] }).flat())
    }

    useEffect(() => {
        // const handleTabKeyPress = (event: {
        //     key: string
        //     shiftKey: any
        //     preventDefault: () => void
        // }) => {
        //     if (event.key === 'Tab') {
        //         if (event.shiftKey) {
        //             // Shift + Tab (backward)
        //             if (document.activeElement === firstInputRef.current) {
        //                 event.preventDefault()
        //                 lastInputRef.current?.focus()
        //             }
        //         } else {
        //             // Tab (forward)
        //             if (document.activeElement === lastInputRef.current) {
        //                 event.preventDefault()
        //                 firstInputRef.current?.focus()
        //             }
        //         }
        //     }
        // }
        const currentServiceLineEnum = getServiceLineEnum(NTSPElements?.ConsultServices, form.fk_ConsultService)
        const allSymptoms = NTSPElements?.Symptoms || []
        const filteredSymptoms = allSymptoms.filter((s) => {
            if(NTSPElements?.SymptomServiceMapping && NTSPElements?.SymptomServiceMapping.length>0 && NTSPElements?.SymptomServiceMapping.findIndex(mapping=>mapping.fk_Symptom===s._key && mapping.ServiceLineEnum===currentServiceLineEnum)!==-1 &&
            s.IsHistory===false){ 
              return true;
            }
            return false;
        })
        const allowedIds = new Set(filteredSymptoms.map((s) => s._key))
        // prune any previously selected symptoms that are no longer allowed
        // const prunedSelected = (form.Symptoms || []).filter((id) => allowedIds.has(id))
        // setSelectedSymptoms(
        //     prunedSelected.map((symptomId) => ({
        //         label:
        //             filteredSymptoms.find((s) => s._key === symptomId)?.FriendlyName ||
        //             symptomId.toString(),
        //         value: symptomId.toString(),
        //     }))
        // )
        const tempTypeMap: { [s: string]: { [s: string]: { label: string; value: string }[] } } = {}
        const tempSymptomTypeMap: { [key: string]: string } = {}
        // const tempCategoryMap : {[s:string]:Set<NTSPElement>} = {}

        // type => points to a set of categories => each category maps to array of symptoms in form {label: '', value: ''}
        filteredSymptoms.forEach((symptom) => {
            // Build hierarchy: SymptomType -> categories; category-less symptoms stored under empty key ''
            const categoryRaw = symptom.SymptomCategory || ''
            const type = symptom.SymptomType || ''
            tempSymptomTypeMap[symptom._key + ''] = type
            if (!tempTypeMap[type]) tempTypeMap[type] = {}
            const categoryKey = categoryRaw.trim() === '' ? '' : categoryRaw
            if (tempTypeMap[type][categoryKey]) {
                tempTypeMap[type][categoryKey] = tempTypeMap[type][categoryKey].concat({
                    label: symptom.FriendlyName,
                    value: symptom._key.toString(),
                })
            } else {
                tempTypeMap[type][categoryKey] = [
                    { label: symptom.FriendlyName, value: symptom._key.toString() },
                ]
            }
        })
        setTypeMap(tempTypeMap)
        // setSymptomTypeMap(tempSymptomTypeMap)

        const tempMappedSelected: { [s: string]: { value: string; label: string }[] } = {}
        form.Symptoms?.forEach((symptomId) => {
            const type = tempSymptomTypeMap[symptomId + ''] || ''
            if (!!tempMappedSelected[type]) {
                tempMappedSelected[type] = tempMappedSelected[type].concat({
                    label:
                        NTSPElements?.Symptoms?.find((s) => s._key === symptomId)?.FriendlyName ||
                        symptomId.toString(),
                    value: symptomId.toString(),
                })
            } else {
                tempMappedSelected[type] = [
                    {
                        label:
                            NTSPElements?.Symptoms?.find((s) => s._key === symptomId)
                                ?.FriendlyName || symptomId.toString(),
                        value: symptomId.toString(),
                    },
                ]
            }
        })
        setSelectedSymptoms(tempMappedSelected)

        // const formElement = formRef.current
        // if (formElement) {
        //     formElement.addEventListener('keydown', handleTabKeyPress)
        // }

        // return () => {
        //     if (formElement) {
        //         formElement.removeEventListener('keydown', handleTabKeyPress)
        //     }
        // }
    }, [form.CaseId, form.fk_ConsultService, NTSPElements?.Symptoms])

    // useEffect(() => {
    //     const tempSymptoms = new Set<number>(form.Symptoms || [])
    //     Object.keys(mappedSelected).forEach((typeKey) => mappedSelected[typeKey].map((symptom) => tempSymptoms.add(parseInt(symptom.value)))) 
    //     setForm((prev: ApiDTO_NTSPform) => ({
    //         ...prev,
    //         Symptoms: Array.from(tempSymptoms)
    //         // selectedSymptoms?.map((symptom) => parseInt(symptom.value)) || [],
    //     }))
    // }, [mappedSelected])

    const [formError, setFormError] = useState<string>('')

    useEffect(() => {
        if (!Object.values(errors) || Object.values(errors).join('').length === 0) {
            setFormError('')
        }
    }, [errors])

    const wrapHandleSave = async () => {
        setSubmitted(true)
        setSaving(true)
        const tempErrors = validateForm(form, validationSchema, NTSPElements)
        // Merge existing errors (including date validation errors) with new validation errors
        setErrors(tempErrors)
        // Check if there are any errors (from validation schema or date validation)
        if (Object.values(tempErrors).some(Boolean)) {
            setFormError('Please fix the errors before saving.')
            setSaving(false)
            return
        } else {
            setErrors({})
            setFormError('')
            if (debouncedHandleSave) await debouncedHandleSave() //FP-12575 Use debounced save to prevent multiple rapid clicks, but await it to ensure completion before proceeding
            setSaving(false)
            return
        }
    }

    const wrapHandleClear = async () => {
        setSubmitted(true)
        setSaving(true)
        const tempErrors = validateForm(form, validationSchema, NTSPElements)
        setErrors(tempErrors)
        if (Object.values(tempErrors).some(Boolean)) {
            setFormError('Please fix the errors before saving.')
            setSaving(false)
            return
        } else {
            setErrors({})
            setFormError('')
            if (handleSave) await handleSave(true)
            if (handleClear) handleClear()
            setSaving(false)
            return
        }
    }

    const handleChange = (e: any) => {
        //e.preventDefault();
        const { name, value, type } = e.target
        let updatedValue = value
        // const tempErrors: FieldErrors = { ...errors } //commented out prevent othet tab error affect on  this tab
        const tempErrors: FieldErrors = {}
        const schema = validationSchema[name]
        // NOTE: this is very fragile and we should revisit. If there is any scenario where an error 
        // relies on a value that does not match the value returned from e.target it will not show the correct error
        // (for example you have to look at the target.checked property for a checkbox input not its value)
        const tempValue = name === "fk_FollowupNeeded" ? Number(!(e.target as HTMLInputElement).checked) : value;

        const nextFormValue =
            name === 'fk_HandOffCriteria'
                ? Number(tempValue)
                : name === 'flag_HandOff2NTSPConsult'
                    ? (e.target as HTMLInputElement).checked
                    : tempValue

        const nextForm = { ...form, [name]: nextFormValue }

        tempErrors[name] = typeof schema === 'function' ? schema(nextForm, NTSPElements) : schema || ''

        if (['fk_HandOffCriteria', 'flag_HandOff2NTSPConsult'].includes(name)) {
            const consultantSchema = validationSchema['fk_Consultant']
            if (typeof consultantSchema === 'function') {
                tempErrors['fk_Consultant'] = consultantSchema(nextForm, NTSPElements)
            }
        }

        if (name === 'FinCenter') {
            const ssnSchema = validationSchema['PatientSSN']
            tempErrors['PatientSSN'] = typeof ssnSchema === 'function' ? ssnSchema({...form, ['FinCenter']: value }) : ssnSchema || ''
        }

        const formatPhoneNumberWithExtension = (val: string) => {
            const lowerVal = val.toLowerCase()
            const extMatch = lowerVal.match(/(?:x|ext)\s*(.*)$/) // match x or ext (case-insensitive)
            const extension = extMatch ? extMatch[1].replace(/\D/g, '') : ''
            const mainNumber = lowerVal.replace(/(?:x|ext)\s*.*/g, '') // strip ext from main number
            const cleanedMain = mainNumber.replace(/\D/g, '').slice(0, 10) // keep only first 10 digits

            const match = cleanedMain.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)
            let formattedMain = ''
            if (match) {
                const [, area, prefix, line] = match
                if (line) formattedMain = `(${area}) ${prefix}-${line}`
                else if (prefix) formattedMain = `(${area}) ${prefix}`
                else if (area) formattedMain = `(${area}`
            }

            // Append extension if present or if user typed `x` or `ext`
            if (extMatch) {
                return `${formattedMain} x${extension.trim()}`
            }

            return formattedMain
        }
        if (name === 'fk_Consultant') {
            const selectedType = NTSPElements?.Consultants?.find(
                (c) => c._key === Number(value)
            );
            // setStaffPhone(selectedType?.StaffPhoneNumber || '')
        }
        updatedValue = name === 'TCSNumber' ? formatPhoneNumberWithExtension(value) : value
        if (name === 'fk_ConsultService') {
            setForm((prev: ApiDTO_NTSPform) => ({
                ...prev,
                fk_FollowUps:
                    typeof form.fk_FollowUps !== 'number'
                        ? form.fk_FollowUps?.filter((f: number) => f === teleEEGServiceKey)
                        : [-1], 
                fk_EEGType: Number(value) === teleEEGServiceKey ? prev.fk_EEGType : -1,
                fk_ConsultantType:Number(value) !== teleEEGServiceKey ||
                                  form.fk_Consultant!=-1 ? form.fk_ConsultantType  : -1
            }))
        }
        if (name === 'NewNote') {
            setNewNote(value)
            setRemainingNotes(2048 - e.currentTarget.value.length)
            return
        }
        // Special case for the diagnosis discussed checkbox
        if (name === 'flag_DiagnosisDiscussed') {
            const isChecked = (e.target as HTMLInputElement).checked
            // When unchecking the diagnosis discussed checkbox, also clear the diagnosis time
            if (!isChecked) {
                setForm((prev: ApiDTO_NTSPform) => ({
                    ...prev,
                    flag_DiagnosisDiscussed: false,
                    ts_DiagnosisTime: null,
                }))
            } else {
                setForm((prev: ApiDTO_NTSPform) => ({
                    ...prev,
                    flag_DiagnosisDiscussed: true,
                }))
            }
            return
        }
       
        if (typeof value === 'string') {
            updatedValue = value.trimStart() // only trim the start to allow spaces within the string
        }

        if (name === 'PatientSSN') {
            updatedValue = value.replace(/\D/g, '').slice(0, 9)
        }

        if (name === 'PatientDOB' && !!value) {
            // calculate age from DOB
            setForm((prev) => ({
                ...prev,
                PatientAge: getAge(value),
            }))
        }

        if (name === 'fk_Facility') {
            const selectedFacility = NTSPElements?.Facilities?.find((f) => f._key === Number(value))
            if (selectedFacility && selectedFacility.TZCode) {
                setTimezoneState(tzCodeToIANA(selectedFacility.TZCode))
                dispatch(setTimezone(tzCodeToIANA(selectedFacility.TZCode)))
            } else {
                setTimezoneState('')
                dispatch(setTimezone(''))
            }
            if (selectedFacility) {
                const facilityCode =
                    NTSPElements?.Facilities?.find((c) => c._key === selectedFacility._key)
                        ?.facilityCode || 'FacilityCode'
                const caseParts = form.CaseId.split('-')
                caseParts[0] = facilityCode

                setForm((prev) => ({
                    ...prev,
                    CaseId: caseParts.join('-'),
                }))
            }
        }
        setForm((prev: ApiDTO_NTSPform) => {
            // Prepare next state
            const next = {
                ...prev,
                [name]:
                    name === 'PatientAge'
                        ? Math.min(Number(updatedValue), 199)
                        : name === 'PatientDOB' && updatedValue === ''
                          ? null
                          : name === 'fk_CallerPosition' || name === 'fk_HandOffCriteria'
                          ? Number(updatedValue)
                           : name === "fk_FollowupNeeded" 
                            ? Number(!(e.target as HTMLInputElement).checked)
                            : type === 'checkbox'
                                ? (e.target as HTMLInputElement).checked
                                : type === 'select-one'
                                ? Number(updatedValue)
                                : updatedValue,
            }

            if(name === 'flag_UnknownLKW' && (e.target as HTMLInputElement).checked){
                next.ts_LKW = null
                next.ts_LKWDate = null
                next.ts_LKWTime = null
            }

            return next
        })

        setErrors(tempErrors)
        if (
            submitted &&
            Object.values(tempErrors) &&
            Object.values(tempErrors).join('').length > 0
        ) {
            setFormError('Please fix the errors before saving.')
            return
        } else {
            setFormError('')
        }
    }

    useEffect(() => {
        setForm((prev: ApiDTO_NTSPform) => ({
            ...prev,
            NewNote: NewNote,
        }))
    }, [NewNote])

    // Sync form.NewNote back to local NewNote state only when cleared after save
    // This prevents flickering when switching tabs with provider notes in form.NewNote
    useEffect(() => {
        const formNoteValue = form.NewNote || ''
        const isCleared = formNoteValue === '' && prevFormNewNoteRef.current !== ''
        
        if (isCleared && NewNote !== '') {
            // Form was cleared (after save), so clear the local state too
            setNewNote('')
            setRemainingNotes(2048)
        }
        prevFormNewNoteRef.current = formNoteValue
    }, [form.NewNote, NewNote])

    const handleBlur = (e: any) => {
        const { name, value } = e.target
        if (validationSchema[name]) {
            setErrors((prev: { [s: string]: string }) => ({
                ...prev,
                [name]: validationSchema[name]({...form, [name]: value }),
            }))
        }
        if (name === 'CallerFullName' && !form.ProviderCaringName) {
            //default provider to callername
            setForm((prev: ApiDTO_NTSPform) => ({
                ...prev,
                ProviderCaringName: value,
            }))
        }
    }

    // Handler for date field validation errors from DatePicker
    const handleDateValidationError = (fieldName: string) => (error: string) => {
        setErrors((prev: { [s: string]: string }) => ({
            ...prev,
            [fieldName]: error,
        }))
    }

    useEffect(() => {
        const handleClassChange = () => {
            setIsNightMode(document.body.classList.contains('night-mode'))
        }

        const observer = new MutationObserver(() => {
            handleClassChange()
        })

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })

        return () => {
            observer.disconnect()
        }
    }, [])

    useEffect(() => {
        if (form.fk_Facility !== -1 && !isSaved) {
            setForm((prev: ApiDTO_NTSPform) => ({
                ...prev,
                ts_Consult: getNowInFacilityTimezone(form.fk_Facility, NTSPElements, tzCodeToIANA),
            }))
        }
    }, [form.fk_Facility, NTSPElements?.Facilities, setForm])

    const setConsultTimeToNow = () => {
        setForm((prev: ApiDTO_NTSPform) => ({
            ...prev,
            ts_Consult: getNowInFacilityTimezone(form.fk_Facility, NTSPElements, tzCodeToIANA),
        }))
    }

    return (
        <>
            {form.CaseId && isSaved &&
                <div className='sticky-Patient-header'>
                    <PatientDetailsHeader
                        form={form}
                        NTSPElements={NTSPElements}
                    />
                </div>
            }
            <form
                onSubmit={(e) => {
                    e.preventDefault()
                    wrapHandleSave()
                }}
                className="ntsp-form-container"
                ref={formRef}
            >
                {!form.CaseId ? (
                    <FoundationsButton
                        customStyle={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 'auto',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translateX(-50%) translateY(-50%)',
                        }}
                        id="ntsp_new_case"
                        buttonClasses="app-button"
                        onClick={() =>
                            {
                                const tempFormState = isCustomerSite ? {...initialFormState, fk_Outcome:-1} : initialFormState
                                newCase != undefined ? newCase() : setForm({ ...tempFormState })
                            }
                        }
                        disabled={isLoadingNTSPElements || !NTSPElements}
                    >
                        New Case
                    </FoundationsButton>
                ) : (
                    <>
                        {/* Columns container */}
                        <div className="patient-container">
                            {/* Column 1 */}
                            <div className="patient-details-block">
                                {/* VA Facility */}
                                <div className="form-group">
                                    <label className="" htmlFor="fk_Facility">
                                        VA Facility*:
                                    </label>
                                    <span>
                                        <select
                                            name="fk_Facility"
                                            id="fk_Facility"
                                            value={form.fk_Facility}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="ntsp-fields"
                                            tabIndex={1}
                                            ref={firstInputRef}
                                            disabled={isSaved}
                                            title={
                                                isSaved
                                                    ? 'Facility cannot be changed after case creation'
                                                    : ''
                                            }
                                        >
                                            <option value="-1">-Select Facility-</option>
                                            {isCustomerSite ?
                                                NTSPElements?.Facilities?.filter((facility: NTSPElement) => {
                                                  const userFacilities = getUserFacilities(LocationMetadataId);
                                                 if(userFacilities && userFacilities.length>0 && 
                                                    userFacilities.includes(facility._key))
                                                    {
                                                     return true;
                                                    }
                                                    else { return false; }
                                            }).map((Facility) => (
                                                <option key={Facility._key} value={Facility._key}>
                                                    {Facility.FacilityName}
                                                </option>
                                            ))
                                            
                                            :
                                                
                                            NTSPElements?.Facilities?.map((Facility) => (
                                                <option key={Facility._key} value={Facility._key}>
                                                    {Facility.FacilityName}
                                                </option>
                                            ))}
                                        
                                        </select>
                                        {errors.fk_Facility && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    position: 'absolute',
                                                    lineHeight: '1',
                                                }}
                                            >
                                                {errors.fk_Facility + ''}
                                            </div>
                                        )}
                                    
                                    </span>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="fk_ConsultService" className="">
                                        Service Line*:
                                    </label>
                                    <span>
                                        <select
                                            className="ntsp-fields"
                                            id="fk_ConsultService"
                                            name="fk_ConsultService"
                                            value={form.fk_ConsultService}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            tabIndex={5}
                                        >
                                            <option value="-1">-Select Service Line-</option>
                                            {NTSPElements?.ConsultServices?.filter((service: NTSPElement) => { //FP-14539 Filter services based on facility support and user privileges
                                                const allowedByFacility = isServiceAllowedForFacility(
                                                    service,
                                                    form.fk_Facility
                                                )

                                                if (!isCustomerSite) return allowedByFacility

                                                const userServiceLines = getUserServiceLines(NTSPElements)
                                                const allowedByUser =
                                                    userServiceLines &&
                                                    userServiceLines.length > 0 &&
                                                    userServiceLines.includes(service._key)

                                                return allowedByUser && allowedByFacility
                                            }).map((service: NTSPElement) => (
                                                <option key={service._key} value={service._key}>
                                                    {service.FriendlyName}
                                                </option>
                                            ))}{/* FP-14539 End of service line filter */}
                                        </select>
                                        {errors && errors.fk_ConsultService && (
                                            <div style={{ color: 'red', position: 'absolute' }}>
                                                {errors.fk_ConsultService + ''}
                                            </div>
                                        )}
                                    </span>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="CallerFullName">Name of Caller:</label>
                                    <input
                                        className="ntsp-fields"
                                        type="text"
                                        id="CallerFullName"
                                        value={form.CallerFullName}
                                        name="CallerFullName"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        tabIndex={8}
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="EEG"
                                        className={
                                            teleEEGServiceKey !== form.fk_ConsultService
                                                ? 'disabled'
                                                : ''
                                        }
                                    >
                                        EEG Type:
                                    </label>
                                    <span>
                                        <select
                                            className="ntsp-fields"
                                            id="EEG"
                                            name="fk_EEGType"
                                            value={form.fk_EEGType}
                                            onChange={handleChange}
                                            disabled={teleEEGServiceKey !== form.fk_ConsultService}
                                            title={
                                                teleEEGServiceKey !== form.fk_ConsultService
                                                    ? 'EEG Type is disabled for non-EEG consults'
                                                    : ''
                                            }
                                            tabIndex={10}
                                        >
                                            <option value="-1">-Select EEG Type-</option>
                                            {NTSPElements?.EEGType?.map((EEG: NTSPElement) => (
                                                <option key={EEG._key} value={EEG._key}>
                                                    {EEG.FriendlyName}
                                                </option>
                                            ))}
                                        </select>
                                    </span>
                                </div>
                            </div>

                            {/* Column 2 */}
                            <div className="patient-details-block">
                                {/* Consult Time */}
                                <div className="form-group">
                                    <label className="" htmlFor="ts_Consult">
                                        Initial Consult Time*: <br />{' '}
                                        <span style={{ fontSize: '11px', color: '#666' }}>
                                            (Patient Facility Time)
                                        </span>
                                    </label>
                                    <span>
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '0.5rem',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <DatePicker
                                                id="ts_Consult"
                                                name="ts_Consult"
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                tabIndex={2}
                                                showMasking={true}
                                                //className="ntsp-fields"
                                                inputClass="ntsp-fields"
                                                timeformat="HH:mm"
                                                showTime={true}
                                                startingDate={
                                                    form.ts_Consult && form.fk_Facility !== -1
                                                        ? new Date(form.ts_Consult)
                                                        : null
                                                }
                                                setStartingDate={(dateString) => {
                                                    const event = {
                                                        target: {
                                                            name: 'ts_Consult',
                                                            value: dateString,
                                                        },
                                                    }
                                                    handleChange(event)
                                                    if (handleBlur) {
                                                        handleBlur(event)
                                                    }
                                                }}
                                                interval={5}
                                                placeholder="Select Consult Date & Time"
                                                classes={errors.ts_Consult ? 'error-field' : ''}
                                                style={{ width: '155px' }} // Add fixed width here
                                                isClearable={true}
                                                calendarClosed={true}
                                                onValidationError={handleDateValidationError('ts_Consult')}
                                            />
                                            <button
                                                type={'button'}
                                                className="d-inline-block app-button"
                                                tabIndex={3}
                                                onClick={setConsultTimeToNow}
                                            >
                                                Now
                                            </button>
                                            {/* <span style={{lineHeight:"2.1", fontSize: '12px'}}>{IANAToTzCode(timezone)}</span> */}
                                            {/* <select
                                                name="ts_Consult_tz"
                                                tabIndex={11}
                                                style={{ width: '64px', fontSize: '12px' }}
                                            >
                                                <option value="1">EST</option>
                                            </select> */}
                                        </div>
                                        {errors.ts_Consult && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    fontSize: '12px',
                                                    marginTop: '4px',
                                                    maxWidth: '155px',
                                                }}
                                            >
                                                {errors.ts_Consult + ''}
                                            </div>
                                        )}
                                    </span>
                                </div>
                                {/* Patient Location */}
                                <div className="form-group">
                                    <label
                                        className=""
                                        htmlFor="fk_PatientLocation"
                                    >
                                        Patient Location*:
                                    </label>
                                    <span>
                                        <select
                                            name="fk_PatientLocation"
                                            id="fk_PatientLocation"
                                            value={form.fk_PatientLocation}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="ntsp-fields"
                                            tabIndex={6}
                                            style={{ width: '155px' }}
                                        >
                                            <option value="-1">-Select Location-</option>
                                            {NTSPElements?.PatientLocations?.map((Location) => (
                                                <option key={Location._key} value={Location._key}>
                                                    {Location.FriendlyName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.fk_PatientLocation && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    position: 'absolute',
                                                    lineHeight: '1',
                                                }}
                                            >
                                                {errors.fk_PatientLocation + ''}
                                            </div>
                                        )}
                                    </span>
                                </div>
                                <div className="form-group">
                                    <label>Telephone # of Caller:</label>
                                    <InputMask
                                        mask="(999) 999-9999 x999999"
                                        maskChar=""
                                        value={form.CallerPhoneNumber || ''}
                                        onChange={handleChange}
                                        tabIndex={9}
                                    >
                                        {(inputProps: any) => (
                                            <input
                                                {...inputProps}
                                                className="ntsp-fields"
                                                type="tel"
                                                name="CallerPhoneNumber"
                                                maxLength={22}
                                                placeholder="(415) 123-4567 x123456"
                                                //tabIndex={11}
                                            />
                                        )}
                                    </InputMask>
                                </div>
                                 <div className="form-group">
                                    <label style={{maxWidth: '150px', maxHeight:'37px'}} htmlFor="ProviderCaringName">
                                        Provider Caring for patient:
                                    </label>
                                    <input
                                        type="text"
                                        className="ntsp-fields"
                                        onChange={handleChange}
                                        id="ProviderCaringName"
                                        value={form.ProviderCaringName}
                                        name="ProviderCaringName"
                                        tabIndex={11}
                                    />
                                </div>
                            </div>

                            {/* Column 3 */}
                            <div className="patient-details-block">
                                {/* LKW Date */}
                                <div className="form-group">
                                    <label htmlFor="fk_Outcome_2">Status/Type:</label>
                                    <select
                                        className="ntsp-fields"
                                        id="fk_Outcome_2"
                                        name="fk_Outcome"
                                        value={form.fk_Outcome}
                                        onChange={handleChange}
                                        tabIndex={4}
                                        title={ isCustomerSite && form.fk_Outcome !== -1 ? 'Status cannot be changed once set at customer sites' : 'Set case status' }
                                        disabled={isCustomerSite && form.fk_Outcome !== -1}
                                    >
                                      
                                        {isCustomerSite ?
                                            <>
                                                <option key="-1" value="-1">
                                                    {'Pending'}
                                                </option>
                                                {form.fk_Outcome !== -1 && 
                                                    <option key={form.fk_Outcome} value={form.fk_Outcome}>
                                                        {NTSPElements?.Outcome?.find((status: NTSPElement) => status._key === form.fk_Outcome)?.FriendlyName || 'Unknown Status'}
                                                    </option>
                                                }
                                            </> 
                                            :
                                            <>
                                            {form.fk_Outcome === -1 &&
                                           <option key="-1" value="-1">
                                                    {'Pending'}
                                                </option>
                                            }   
                                            {form.fk_Outcome !== -1 &&
                                           <option key="-1" value="-1">
                                                    {'-Select Status-'}
                                                </option>
                                            }  
                                            {NTSPElements?.Outcome?.map((Status: NTSPElement) => (
                                                <option key={Status._key} value={Status._key}>
                                                    {Status.FriendlyName}
                                                </option>
                                            ))}
                                            </>
}
                                    </select>
                                </div>
                                <div id="callerPosition" className="form-group">
                                    <label>Position of Caller:</label>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', lineHeight: '1' }}>
                                        {NTSPElements?.CallerPosition?.map(
                                            (pos: NTSPElement, index: number) => (
                                                <div key={pos._key}>
                                                    <input
                                                        type="radio"
                                                        name="fk_CallerPosition"
                                                        id={`callerPosition${pos._key}`}
                                                        value={pos._key}
                                                        checked={form.fk_CallerPosition === pos._key}
                                                        onChange={handleChange}
                                                        tabIndex={index === 0 ? 7 : -1}
                                                        ref={index === 0 ? firstInputRef : undefined}
                                                    />
                                                    <label
                                                        className="ml-2"
                                                        style={{ minWidth: '65px' }}
                                                        htmlFor={`callerPosition${pos._key}`}
                                                    >
                                                        {pos.FriendlyName}
                                                    </label>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                                {!isCustomerSite && (
                                <div
                                    className="form-group"
                                    style={{
                                        //flexDirection: 'column',
                                        //gap: '0rem',
                                        //alignItems: 'flex-start',
                                        //maxWidth: '175px',
                                    }}
                                >
                                    <label className="">Video Conferencing:</label>
                                    <ul
                                        className="list-group ntsp-video"
                                        style={{ margin: 0, padding: 0 }}
                                    >
                                        {NTSPElements?.Facilities?.filter(
                                            (f) => f._key === form.fk_Facility
                                        ).flatMap((f) =>
                                            (f.LocationDevice ?? []).map((device) => (
                                                <li key={device._key} className="list-group-item">
                                                    <a
                                                        href={device.URL}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {device.DeviceName}
                                                    </a>
                                                </li>
                                            ))
                                        )}
                                        {!NTSPElements?.Facilities?.some(
                                            (f) =>
                                                f._key === form.fk_Facility &&
                                                Array.isArray(f.LocationDevice) &&
                                                f.LocationDevice.length > 0
                                        ) && (
                                            <li
                                                className="text-muted"
                                                style={{ padding: '0.5rem', textAlign: 'center' }}
                                            >
                                                No video conferencing devices available.
                                            </li>
                                        )}
                                    </ul>
                                </div>
                                )}
                            </div>
                        </div>
                        <hr className="mb-1" />
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                fontWeight: 500,
                                fontSize: 16,
                                cursor: 'pointer',
                                marginLeft: '-5px',
                                padding: '5px',
                                marginBottom: '1.5rem',
                            }}
                            onClick={() => setOpenPatientDetails((v) => !v)}
                        >
                            <span
                                style={{
                                    fontSize: 14,
                                    marginRight: 8,
                                    userSelect: 'none',
                                    transition: 'transform 0.2s',
                                    transform: togglePatientDetails ? 'rotate(90deg)' : 'rotate(0deg)',
                                }}
                            >
                                ▶
                            </span>
                            Patient Information
                        </div>
                        {togglePatientDetails && (
                            <>
                            <div className="patient-information-container">
                                <div className="patient-details-block">
                                {/* Last Name */}
                                <div className="form-group">
                                    <label className="" htmlFor="PatientLastName">
                                        Last Name*:
                                    </label>
                                    <span>
                                        <input
                                            type="text"
                                            id="PatientLastName"
                                            name="PatientLastName"
                                            value={form.PatientLastName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="ntsp-fields"
                                            tabIndex={12}
                                        />
                                        {errors.PatientLastName && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    position: 'absolute',
                                                    lineHeight: '1',
                                                }}
                                            >
                                                {errors.PatientLastName + ''}
                                            </div>
                                        )}
                                    </span>
                                </div>
                                {/* DOB / Age */}
                                <div className="form-group">
                                    <label className="" htmlFor="PatientDOB">
                                        DOB / Age:
                                    </label>
                                    <span>
                                    <div
                                        style={{ display: 'flex', alignItems: 'center', gap: '0.5rem',width: '100%',maxWidth: '155px' }}
                                    >
                                        <DatePicker
                                            id="PatientDOB"
                                            name="PatientDOB"
                                            dateFormat="MM/dd/yyyy"
                                            tabIndex={15}
                                            //className="ntsp-fields"
                                            showTime={false}
                                            showMasking={true}
                                            startingDate={
                                                form.PatientDOB ? new Date(form.PatientDOB) : null
                                            }
                                            setStartingDate={(dateString) => {
                                                const event = {
                                                    target: {
                                                        name: 'PatientDOB',
                                                        value: dateString,
                                                    },
                                                }
                                                handleChange(event)
                                            }}
                                            inputClass="ntsp-fields"
                                            placeholder="Select DOB"
                                            style={{ width: '60%',maxWidth: '93px' }}
                                            isClearable={true}
                                            onValidationError={handleDateValidationError('PatientDOB')}
                                        />
                                        <span>/</span>
                                        <input
                                            type="number"
                                            id="PatientAge"
                                            name="PatientAge"
                                            value={form.PatientAge}
                                            onChange={handleChange}
                                            tabIndex={16}
                                            placeholder="age"
                                            className="ntsp-fields"
                                            style={{ width: '40%', maxWidth: '40px' }}
                                        />
                                    </div>
                                    {errors.PatientDOB && (
                                        <div
                                            style={{
                                                color: 'red',
                                                fontSize: '12px',
                                                marginTop: '4px',
                                                maxWidth: '155px',
                                            }}
                                        >
                                            {errors.PatientDOB + ''}
                                        </div>
                                    )}
                                    </span>
                                </div>
                                <div className="form-group">
                                    <label className="" htmlFor="ts_LKWDate">
                                        LKW Date: <br />
                                        <span style={{ fontSize: '11px', color: '#666' }}>
                                            (Patient Facility Time)
                                        </span>
                                    </label>
                                    <span>
                                    <DatePicker
                                        id="ts_LKWDate"
                                        name="ts_LKWDate"
                                        dateFormat="MM/dd/yyyy"
                                        tabIndex={19}
                                        showMasking={true}
                                        //className="ntsp-fields"
                                        inputClass="ntsp-fields"
                                        showTime={false}
                                        startingDate={
                                            !!form.ts_LKWDate && !form.flag_UnknownLKW
                                                ? new Date(form.ts_LKWDate)
                                                : null
                                        }
                                        setStartingDate={(dateString) => {
                                            const event = {
                                                target: {
                                                    name: 'ts_LKWDate',
                                                    value: dateString,
                                                },
                                            }
                                            handleChange(event)
                                        }}
                                        placeholder="Select LKW Date"
                                        style={{ width: '60%' }}
                                        disabled={form.flag_UnknownLKW}
                                        title={form.flag_UnknownLKW ? 'LKW is set to unknown' : ''}
                                        isClearable={true}
                                        onValidationError={handleDateValidationError('ts_LKWDate')}
                                        
                                    />
                                    {errors.ts_LKWDate && (
                                        <div
                                            style={{
                                                color: 'red',
                                                fontSize: '12px',
                                                marginTop: '4px',
                                                maxWidth: '155px',
                                            }}
                                        >
                                            {errors.ts_LKWDate + ''}
                                        </div>
                                    )}
                                    </span>
                                </div>
                                <div
                                    className="form-group"
                                    style={{
                                        //flexDirection: 'column',
                                        //gap: '1rem',
                                        alignItems: 'flex-start',
                                        //maxWidth: '175px',
                                    }}
                                >
                                    <label className="" htmlFor="ts_WakeUpStrokeDate">
                                        Wake Up Stroke Date: <br />
                                        <span style={{ fontSize: '11px', color: '#666' }}>
                                            (Patient Facility Time)
                                        </span>
                                    </label>
                                    <span>
                                    <DatePicker
                                        id="ts_WakeUpStrokeDate"
                                        name="ts_WakeUpStrokeDate"
                                        dateFormat="MM/dd/yyyy"
                                        tabIndex={22}
                                        inputClass="ntsp-fields"
                                        showMasking={true}
                                        showTime={false}
                                        startingDate={
                                            !!form.ts_WakeUpStrokeDate
                                                ? new Date(form.ts_WakeUpStrokeDate)
                                                : null
                                        }
                                        setStartingDate={(dateString) => {
                                            const event = {
                                                target: {
                                                    name: 'ts_WakeUpStrokeDate',
                                                    value: dateString,
                                                },
                                            }
                                            handleChange(event)
                                            if (handleBlur) {
                                                handleBlur(event)
                                            }
                                        }}
                                        interval={5}
                                        placeholder="Select Wake Up Stroke Date"
                                        style={{ width: '155px' }} // Add fixed width here
                                        isClearable={true}
                                        onValidationError={handleDateValidationError('ts_WakeUpStrokeDate')}
                                    />
                                    {errors.ts_WakeUpStrokeDate && (
                                        <div
                                            style={{
                                                color: 'red',
                                                fontSize: '12px',
                                                marginTop: '4px',
                                                maxWidth: '155px',
                                            }}
                                        >
                                            {errors.ts_WakeUpStrokeDate + ''}
                                        </div>
                                    )}
                                    </span>
                                </div>
                                <div className="form-group">
                                    <label>
                                        ED Arrival Date: <br />
                                        <span style={{ fontSize: '11px', color: '#666' }}>
                                            (Patient Facility Time)
                                        </span>
                                    </label>
                                    <span>
                                        <DatePicker
                                            id="ts_EDArrivalDateOnly"
                                            name="ts_EDArrivalDateOnly"
                                            dateFormat="MM/dd/yyyy"
                                            tabIndex={24}
                                            inputClass="ntsp-fields"
                                            showMasking={true}
                                            showTime={false}
                                            title="Set ED Arrival Date"
                                            startingDate={
                                                !!form.ts_EDArrivalDateOnly
                                                    ? new Date(form.ts_EDArrivalDateOnly)
                                                    : null
                                            }
                                            setStartingDate={(dateString) => {
                                                const event = {
                                                    target: {
                                                        name: 'ts_EDArrivalDateOnly',
                                                        value: dateString,
                                                    },
                                                }
                                                handleChange(event)
                                                if (handleBlur) {
                                                    handleBlur(event)
                                                }
                                            }}
                                            interval={5}
                                            placeholder="Select ED Arrival Date"
                                            style={{ width: '155px' }} // Add fixed width here
                                            isClearable={true}
                                            onValidationError={handleDateValidationError('ts_EDArrivalDateOnly')}
                                        />
                                        {errors.ts_EDArrivalDateOnly && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    fontSize: '12px',
                                                    marginTop: '4px',
                                                    maxWidth: '155px',
                                                }}
                                            >
                                                {errors.ts_EDArrivalDateOnly + ''}
                                            </div>
                                        )}
                                        {/* <span className="mx-1" style={{ lineHeight: "2.1", fontSize: "12px" }}>{IANAToTzCode(timezone)}</span> */}
                                    </span>
                                </div>
                            </div>
                            <div className="patient-details-block">
                                {/* Last Name */}
                                {/* First Name */}
                                <div className="form-group">
                                    <label className="" htmlFor="PatientFirstName">
                                        First Name*:
                                    </label>
                                    <span>
                                        <input
                                            type="text"
                                            id="PatientFirstName"
                                            name="PatientFirstName"
                                            value={form.PatientFirstName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="ntsp-fields"
                                            tabIndex={12}
                                        />
                                        {errors.PatientFirstName && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    position: 'absolute',
                                                    lineHeight: '1',
                                                }}
                                            >
                                                {errors.PatientFirstName + ''}
                                            </div>
                                        )}
                                    </span>
                                </div>
                                {/* Sex */}
                                <div className="form-group">
                                    <label className="" htmlFor="fk_PatientSex">
                                        Sex:
                                    </label>
                                    <select
                                        id="fk_PatientSex"
                                        name="fk_PatientSex"
                                        value={form.fk_PatientSex}
                                        onChange={handleChange}
                                        tabIndex={17}
                                        className="ntsp-fields"
                                    >
                                        <option value="-1">-Select Sex-</option>
                                        {NTSPElements?.Sex?.map((sex) => (
                                            <option key={sex._key} value={sex._key}>
                                                {sex.FriendlyName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* LKW Time */}
                                <div className="form-group">
                                    <label className="" htmlFor="ts_LKWTime">
                                        LKW Time: <br />
                                        <span style={{ fontSize: '11px', color: '#666' }}>
                                            (Patient Facility Time)
                                        </span>
                                    </label>
                                    <span>
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '0.5rem',
                                            alignItems: 'center',
                                            maxWidth: '250px',
                                        }}
                                    >
                                        <DatePicker
                                            id="ts_LKWTime"
                                            title={form.flag_UnknownLKW ? 'LKW is set to unknown' : ''}
                                            name="ts_LKWTime"
                                            dateFormat="HH:mm"
                                            tabIndex={20}
                                            showMasking={true}
                                            inputClass="ntsp-fields"
                                            timeformat="HH:mm"
                                            showTime={true}
                                            showTimeSelectOnly={true}
                                            startingDate={
                                                !!form.ts_LKWTime && moment(form.ts_LKW).format('HH:mm') !== DEFAULT_LKW_TIME && !form.flag_UnknownLKW 
                                                    ? new Date(`1970-01-01T${form.ts_LKWTime}:00`)
                                                    :  null
                                            }
                                            setStartingDate={(dateString) => {
                                                const event = {
                                                    target: {
                                                        name: 'ts_LKWTime',
                                                        value: dateString,
                                                    },
                                                }
                                                handleChange(event)
                                            }}
                                            placeholder="Select LKW Time"
                                            classes={errors.ts_Consult ? 'error-field' : ''}
                                            style={{ width: '155px' }} // Add fixed width here
                                            disabled={form.flag_UnknownLKW}
                                            isClearable={true}
                                            calendarClosed={true}
                                            onValidationError={handleDateValidationError('ts_LKWTime')}
                                        />
                                        {/* <select
                                            name="ts_LKW_tz"
                                            style={{ width: '64px', fontSize: '12px' }}
                                            tabIndex={14}
                                            disabled={form.flag_UnknownLKW}
                                        >
                                            <option value="1">EST</option>
                                        </select> */}
                                    </div>
                                    {errors.ts_LKWTime && (
                                        <div
                                            style={{
                                                color: 'red',
                                                fontSize: '12px',
                                                marginTop: '4px',
                                                maxWidth: '155px',
                                            }}
                                        >
                                            {errors.ts_LKWTime + ''}
                                        </div>
                                    )}
                                    </span>
                                </div>
                                <div
                                    className="form-group"
                                    style={{
                                        //flexDirection: 'column',
                                        //gap: '1rem',
                                        alignItems: 'flex-start',
                                        //maxWidth: '175px',
                                    }}
                                >
                                    <label className="" htmlFor="ts_WakeUpStrokeTime">
                                        Wake Up Stroke Time: <br />
                                        <span style={{ fontSize: '11px', color: '#666' }}>
                                            (Patient Facility Time)
                                        </span>
                                    </label>
                                    <span>
                                    <DatePicker
                                        id="ts_WakeUpStrokeTime"
                                        name="ts_WakeUpStrokeTime"
                                        dateFormat="HH:mm"
                                        tabIndex={23}
                                        inputClass="ntsp-fields"
                                        showMasking={true}
                                        timeformat='HH:mm'
                                        showTime={true}
                                        startingDate={
                                            !!form.ts_WakeUpStrokeTime && moment(form.ts_WakeUpStroke).format('HH:mm') !== DEFAULT_LKW_TIME 
                                                ? new Date(`1970-01-01T${form.ts_WakeUpStrokeTime}:00`)
                                                :  null
                                        }
                                        setStartingDate={(dateString) => {
                                            const event = {
                                                target: {
                                                    name: 'ts_WakeUpStrokeTime',
                                                    value: dateString,
                                                },
                                            }
                                            handleChange(event)
                                            if (handleBlur) {
                                                handleBlur(event)
                                            }
                                        }}
                                        interval={5}
                                        placeholder="Select Wake Up Stroke Time"
                                        style={{ width: '155px' }} // Add fixed width here
                                        isClearable={true}
                                        calendarClosed={true}
                                        showTimeSelectOnly={true}
                                        onValidationError={handleDateValidationError('ts_WakeUpStrokeTime')}
                                    />
                                    {errors.ts_WakeUpStrokeTime && (
                                        <div
                                            style={{
                                                color: 'red',
                                                fontSize: '12px',
                                                marginTop: '4px',
                                                maxWidth: '155px',
                                            }}
                                        >
                                            {errors.ts_WakeUpStrokeTime + ''}
                                        </div>
                                    )}
                                    </span>
                                </div>
                                <div className="form-group">
                                    <label>
                                        ED Arrival Time: <br />
                                        <span style={{ fontSize: '11px', color: '#666' }}>
                                            (Patient Facility Time)
                                        </span>
                                    </label>
                                    <span>
                                        <DatePicker
                                            id="ts_EDArrivalTimeOnly"
                                            title={'Set ED Arrival Time'}
                                            name="ts_EDArrivalTimeOnly"
                                            dateFormat="HH:mm"
                                            tabIndex={25}
                                            showMasking={true}
                                            inputClass="ntsp-fields"
                                            timeformat="HH:mm"
                                            showTime={true}
                                            showTimeSelectOnly={true}
                                            startingDate={
                                                !!form.ts_EDArrivalTimeOnly && moment(form.ts_EDArrivalDateOnly).format('HH:mm') !== DEFAULT_LKW_TIME 
                                                    ? new Date(`1970-01-01T${form.ts_EDArrivalTimeOnly}:00`)
                                                    :  null
                                            }
                                            setStartingDate={(dateString) => {
                                                const event = {
                                                    target: {
                                                        name: 'ts_EDArrivalTimeOnly',
                                                        value: dateString,
                                                    },
                                                }
                                                handleChange(event)
                                            }}
                                            placeholder="Select ED Arrival Time"
                                            classes={errors.ts_Consult ? 'error-field' : ''}
                                            style={{ width: '155px' }} // Add fixed width here
                                            isClearable={true}
                                            readOnly={true} 
                                            onValidationError={handleDateValidationError('ts_EDArrivalTimeOnly')}
                                        />
                                        {errors.ts_EDArrivalTimeOnly && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    fontSize: '12px',
                                                    marginTop: '4px',
                                                    maxWidth: '155px',
                                                }}
                                            >
                                                {errors.ts_EDArrivalTimeOnly + ''}
                                            </div>
                                        )}
                                        {/* <span className="mx-1" style={{ lineHeight: "2.1", fontSize: "12px" }}>{IANAToTzCode(timezone)}</span> */}
                                    </span>
                                </div>
                            </div>
                            <div className="patient-details-block">
                                {/* SSN */}
                                <div className="form-group">
                                    <label className="" htmlFor="PatientSSN">
                                        SSN*:
                                    </label>
                                    <span>
                                        <input
                                            type="text"
                                            id="PatientSSN"
                                            name="PatientSSN"
                                            value={form.PatientSSN || ''}
                                            onChange={handleChange}
                                            className="ntsp-fields"
                                            maxLength={9}
                                            placeholder="xxxxxxxxx"
                                            tabIndex={14}
                                        />
                                        {errors.PatientSSN && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    position: 'absolute',
                                                    lineHeight: '1',
                                                }}
                                            >
                                                {errors.PatientSSN + ''}
                                            </div>
                                        )}
                                    </span>
                                </div>

                                {/* FIN */}
                                <div className="form-group">
                                    <label className="" htmlFor="FinCenter">
                                        FIN:
                                    </label>
                                    <input
                                        type="text"
                                        id="FinCenter"
                                        name="FinCenter"
                                        value={form.FinCenter}
                                        onChange={handleChange}
                                        tabIndex={18}
                                        className="ntsp-fields"
                                    />
                                </div>
                                {/* Unknown LKW */}
                                <div className="form-group">
                                    <label className="" htmlFor="flag_UnknownLKW">
                                        LKW Unknown:
                                    </label>
                                    <span><input
                                        type="checkbox"
                                        id="flag_UnknownLKW"
                                        className="ntsp-fields"
                                        name="flag_UnknownLKW"
                                        checked={form.flag_UnknownLKW}
                                        onChange={handleChange}
                                        tabIndex={21}
                                    />
                                    </span>
                                </div>
                                <div className="form-group">
                                    
                           
                                </div>
                            </div>
                            </div>
                            </>
                        )}
                        {/* --- SEPARATOR: Symptoms Reported --- */}
                        <hr className="mb-1" />
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                fontWeight: 500,
                                fontSize: 16,
                                cursor: 'pointer',
                                marginLeft: '-5px',
                                padding: '5px',
                                marginBottom: '1.5rem',
                            }}
                            onClick={() => setOpenSymptoms((v) => !v)}
                        >
                            <span
                                style={{
                                    fontSize: 14,
                                    marginRight: 8,
                                    userSelect: 'none',
                                    transition: 'transform 0.2s',
                                    transform: toggleSymptoms ? 'rotate(90deg)' : 'rotate(0deg)',
                                }}
                            >
                                ▶
                            </span>
                            Initial Symptoms Reported
                        </div>
                        {toggleSymptoms && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '15px 45px',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {/* CategoryGroupedDropdown */}
                                {Object.keys(typeMap)?.map((type) => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '1rem',
                                            width: '21%',
                                            minWidth: 'fit-content',
                                        }}
                                    >
                                        <div className="form-group cursor-pointer">
                                            <label
                                                className={
                                                    ''
                                                }
                                                style={{ width:'150px' }}
                                            >
                                                {type} <br />
                                                Symptoms:
                                            </label>
                                            <span
                                                className={
                                                    'ntsp-fields'
                                                }
                                                style={{ padding: '0px', border: 'none' }}
                                                title={teleEEGServiceKey === form.fk_ConsultService && type !== 'EEG' ? 'Disabled because the consult service is Tele-EEG' : ''}
                                            >
                                                <Select
                                                    isMulti
                                                    options={([
                                                        ...(typeMap[type][''] || []),
                                                        ...Object.keys(typeMap[type])
                                                            .filter((c) => c !== '')
                                                            .map((category) => ({
                                                                label: category,
                                                                options: typeMap[type][category],
                                                            })),
                                                    ]) as any}
                                                    components={{ Group: SymptomGroup as any }}
                                                    value={selectedSymptoms[type] || []}
                                                    onChange={(newValue) =>
                                                        updateSelectedSymptoms(newValue, type)
                                                    }
                                                    styles={customStyles}
                                                    closeMenuOnSelect={false}
                                                    placeholder={'Select Symptoms'}
                                                    // disabled no longer needed due to filtering logic
                                                    isDisabled={false}
                                                    tabIndex={28 + Object.keys(typeMap).indexOf(type)}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                ))}
                                {/* Column 3 */}
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '1rem',
                                        width: '30%',
                                        minWidth: 'fit-content',
                                    }}
                                ></div>
                            </div>
                        )}
                         {/* --- SEPARATOR: Disposition --- */}
                        {!isCustomerSite && (
                        <><hr className="mb-1" /><div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        fontWeight: 500,
                                        fontSize: 16,
                                        cursor: 'pointer',
                                        marginLeft: '-5px',
                                        padding: '5px',
                                        marginBottom: '1.5rem',
                                    }}
                                    onClick={() => setOpenDisposition((v) => !v)}
                                >
                                    <span
                                        style={{
                                            fontSize: 14,
                                            marginRight: 8,
                                            userSelect: 'none',
                                            transition: 'transform 0.2s',
                                            transform: toggleDisposition ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                    >
                                        ▶
                                    </span>
                                    Disposition
                                </div></>
                        )}
                        {!isCustomerSite && toggleDisposition && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '2rem',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {/* Column 1 */}
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '30%',
                                        minWidth: 'fit-content',
                                    }}
                                >
                                    <span>
                                        <div>
                                            {(() => {
                                                const list = NTSPElements?.HandOffCriteria || []
                                                // Get the ServiceLineEnum for the selected consult service (1=Acute, 2=Subacute, 3=TeleEEG)
                                                const selectedServiceLineEnum = getServiceLineEnum(NTSPElements?.ConsultServices, form.fk_ConsultService)
                                                
                                                const processed = list.filter((item) => item.ServiceLineEnum === selectedServiceLineEnum)
                                                
                                                return processed.map((pos: NTSPElement, index: number) => (
                                                    <div key={pos._key}>
                                                        <input
                                                            type="radio"
                                                            name="fk_HandOffCriteria"
                                                            id={`handOff${pos._key}`}
                                                            value={pos._key}
                                                            checked={form.fk_HandOffCriteria === pos._key}
                                                            onChange={handleChange}
                                                            style={{ marginRight: 8, whiteSpace: 'nowrap' }}
                                                            tabIndex={index === 0 ? 33 : -1}
                                                        />
                                                        <label
                                                            className={'ml-2'}
                                                            style={{ minWidth: '65px' }}
                                                            htmlFor={`handOff${pos._key}`}
                                                        >
                                                            {pos.FriendlyName}
                                                        </label>
                                                    </div>
                                                ))
                                            })()}
                                        </div>
                                    </span>
                                        {teleEEGServiceKey !== form.fk_ConsultService && (

                                            <label
                                                className={
                                                    teleEEGServiceKey === form.fk_ConsultService
                                                        ? 'disabled'
                                                        : ''
                                                }
                                            >

                                                <input
                                                    type="checkbox"
                                                    checked={form.flag_HandOff2NTSPConsult}
                                                    name="flag_HandOff2NTSPConsult"
                                                    onChange={handleChange}
                                                    style={{ marginRight: 8, marginTop: 4, whiteSpace: 'nowrap' }}
                                                    title={teleEEGServiceKey === form.fk_ConsultService ? 'Disabled because the consult service is Tele-EEG' : ''}
                                                    disabled={teleEEGServiceKey === form.fk_ConsultService}
                                                    tabIndex={30}
                                                />
                                                Site Requesting Telephone Consultation With National Telestroke
                                                Program (NTSP) Neurologist
                                            </label>
                                        )}
                                </div>

                                {/* Column 2 */}
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '1rem',
                                        width: '35px',
                                        minWidth: 'fit-content',
                                    }}
                                ></div>
                                {/* Column 3 */}
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '1rem',
                                        width: '30%',
                                        minWidth: 'fit-content',
                                    }}
                                >
                                    <div className="form-group">
                                        <label htmlFor="fk_Consultant" className="mb-0">
                                            Consultant{isConsultantRequired(form, NTSPElements) ? '*' : ''}:
                                        </label>
                                        <span style={{ display: 'contents', marginRight: '3px' }}>
                                            <select
                                                onChange={handleChange}
                                                className="ntsp-fields"
                                                id="fk_Consultant"
                                                value={form.fk_Consultant}
                                                name="fk_Consultant"
                                                tabIndex={28}
                                            >
                                                <option value="-1">-Select Consultant-</option>
                                                {consultants?.map(
                                                    (Consultant: NTSPElement) => (
                                                        <option
                                                            key={Consultant._key}
                                                            value={Consultant._key}
                                                        >
                                                            {Consultant.FriendlyName}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                            <select
                                                onChange={handleChange}
                                                className="ntsp-fields"
                                                tabIndex={29}
                                                id="fk_ConsultantType"
                                                value={form.fk_ConsultantType}
                                                title={teleEEGServiceKey === form.fk_ConsultService || form.fk_Consultant==-1 ? 'Disabled because the consult service is Tele-EEG or no consultant selected' : ''}
                                                disabled={teleEEGServiceKey === form.fk_ConsultService ||form.fk_Consultant==-1}
                                                name="fk_ConsultantType"
                                            >
                                                <option value="-1">-Select Consultant type-</option>
                                                {NTSPElements?.ConsultantTypes?.map((consultantTypes) => (
                                                    <option key={consultantTypes._key} value={consultantTypes._key}>
                                                        {consultantTypes.FriendlyName}
                                                    </option>
                                                ))}
                                            </select>
                                            {/* {staffPhone && (
                                                <a href={`tel:${staffPhone}`}>
                                                    <span>{formatPhone(staffPhone)}</span>
                                                    <CopyIcon
                                                        alwaysShow={true}
                                                        copyText={staffPhone}
                                                        height={18}
                                                        width={18}
                                                        id="consultant-phone"
                                                    />
                                                </a>
                                            )} */}
                                        </span>
                                        {errors.fk_Consultant && (
                                            <div style={{ color: 'red', position: 'absolute',marginTop:'2rem' }}>
                                                {errors.fk_Consultant}
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            Handoff Date: <br />
                                            <span style={{ fontSize: '11px', color: '#666' }}>
                                                (Patient Facility Time)
                                            </span>
                                        </label>
                                        <span
                                            style={{
                                                display: 'flex',
                                                gap: '0.5rem',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <DatePicker
                                                //key={"handoff-time-"+form.ts_HandOff}
                                                id="ts_HandOff"
                                                name="ts_HandOff"
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                tabIndex={31}
                                                //className="ntsp-fields"
                                                inputClass="ntsp-fields"
                                                showTime={true}
                                                showMasking={true}
                                                timeformat="HH:mm"
                                                startingDate={
                                                    form.ts_HandOff ? new Date(form.ts_HandOff) : null
                                                }
                                                setStartingDate={(dateString) => {
                                                    const event = {
                                                        target: {
                                                            name: 'ts_HandOff',
                                                            value: dateString,
                                                            type: 'text',
                                                        },
                                                    }
                                                    handleChange(event)
                                                }}
                                                interval={15}
                                                placeholder="Select Handoff Date & Time"
                                                style={{ width: '155px' }}
                                                isClearable={true}
                                                calendarClosed={true}
                                                onValidationError={handleDateValidationError('ts_HandOff')}
                                            />
                                            {/* <span className="mx-1" style={{ lineHeight: "2.1", fontSize: "12px" }}>{IANAToTzCode(timezone)}</span> */}
                                            <button
                                                type={'button'}
                                                className="d-inline-block app-button"
                                                tabIndex={32}
                                                onClick={() => {
                                                    const selectedFacility =
                                                        NTSPElements?.Facilities?.find(
                                                            (f) => f._key === form.fk_Facility
                                                        )
                                                    const ianaTz = selectedFacility?.TZCode
                                                        ? tzCodeToIANA(selectedFacility.TZCode)
                                                        : undefined
                                                    const now = ianaTz
                                                        ? moment.tz(new Date(), ianaTz)
                                                        : moment(new Date())
                                                    setForm((prev: ApiDTO_NTSPform) => ({
                                                        ...prev,
                                                        ts_HandOff: now.format('YYYY-MM-DDTHH:mm'),
                                                    }))
                                                }}
                                            >
                                                Now
                                            </button>
                                        </span>
                                        {errors.ts_HandOff && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    fontSize: '12px',
                                                    marginTop: '4px',
                                                    maxWidth: '155px',
                                                }}
                                            >
                                                {errors.ts_HandOff + ''}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '1rem',
                                        width: '30%',
                                        minWidth: 'fit-content',
                                    }}>
                                    
                                </div> */}
                            </div>
                        )}
                        <hr className="mb-1" />
                        {/* --- ROW 4: Clinical Notes --- */}
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '2rem',
                                flexWrap: 'wrap',
                            }}
                        >
                            {/* Notes/textarea */}
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.3rem',
                                    width: '33%',
                                    overflowWrap: 'break-word',
                                }}
                            >
                                <label htmlFor="NurseNotes" className="mb-1">
                                Nurse Clinical Notes:
                                </label>
                                <div
                                    id="NureseNotes"
                                    className="w-100 mt-2 clinical-Notes"
                                    style={{ height: '6rem', cursor: 'not-allowed' }}
                                >
                                <span>
                                        {nurseNotes?.map((note, idx) => {
                                            // Get facility time zone
                                            const selectedFacility = NTSPElements?.Facilities?.find(f => f._key === form.fk_Facility);
                                            const ianaTz = selectedFacility?.TZCode ? tzCodeToIANA(selectedFacility.TZCode) : undefined;
                                            const noteTime = note.ts_CreationDateTime
                                                ? (ianaTz
                                                    ? moment.tz(note.ts_CreationDateTime, ianaTz).format('MM/DD/YYYY HH:mm')
                                                    : moment(note.ts_CreationDateTime).format('MM/DD/YYYY HH:mm'))
                                                : '';
                                            return (
                                                <div
                                                    className='pcn-note'
                                                    key={note.Id || idx}
                                                    style={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'minmax(180px, 180px) 1fr',
                                                        alignItems: 'center',
                                                        //gap: '1rem',
                                                        marginBottom: '0.35rem',
                                                        wordBreak: 'break-word'
                                                    }}
                                                >
                                                    <span style={{ color: '#888', fontSize: '12px', fontWeight: 500, display: 'inline-block' }}>
                                                        {note.PostedByUserFullName}
                                                        {noteTime && (
                                                            <span style={{ color: '#888', fontSize: '12px', marginLeft: 6 }}>
                                                                ({noteTime}):
                                                            </span>
                                                        )}
                                                    </span>
                                                    <span style={{ whiteSpace: 'pre-wrap', marginLeft: 6 }}>
                                                        {note.Note}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                </span>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.3rem',
                                    width: '33%',
                                    minWidth: 'fit-content',
                                    position: 'relative', // Add relative positioning to contain the counter
                                }}
                            >
                                <label htmlFor="ClinicalNewNote" className="mb-1">
                                New Nursing Note:
                                </label>
                                <textarea
                                    id="ClinicalNewNote"
                                    className="w-100 mt-2"
                                    style={{ height: '6rem' }}
                                    name="NewNote"
                                    maxLength={2048}
                                    placeholder="Add Note"
                                    value={NewNote}
                                    onChange={handleChange}
                                    tabIndex={33}
                                />
                                {remainigNotes !== 2048 && (
                                    <div
                                        style={{
                                            fontSize: '10px',
                                            color: '#ff0000',
                                            textAlign: 'right',
                                            marginTop: '4px',
                                            paddingRight: '4px',
                                        }}
                                        id="NotesRemainingLabel"
                                    >
                                        {remainigNotes} characters remaining
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Buttons */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '1rem',
                                marginTop: '2rem',
                            }}
                        >
                            <FoundationsButton
                                type="submit"
                                buttonClasses="app-button"
                                tabIndex={40}
                                disabled={saving || (isCustomerSite && form.fk_Outcome !== -1)}
                                title={ (isCustomerSite && form.fk_Outcome !== -1) ? "This form is no longer pending and cannot be edited at this site" : "Save the current form"}
                                id={''}
                            >
                                Save
                            </FoundationsButton>
                            <FoundationsButton
                                type="button"
                                buttonClasses="app-button"
                                tabIndex={41}
                                onClick={wrapHandleClear}
                                buttonRef={lastInputRef}
                                disabled={saving || (isCustomerSite && form.fk_Outcome !== -1)}
                                id={''}
                                title={ (isCustomerSite && form.fk_Outcome !== -1) ? "This form is no longer pending and cannot be edited at this site" : "Save and close the current form"}
                                toolTipText="Currently opened case entry form will be saved and closed."
                                tooltipClasses="info-icon"
                            >
                                Close
                            </FoundationsButton>
                        </div>

                        {submitted && formError !== '' && (
                            <div style={{ color: 'red', textAlign: 'right', marginTop: '1rem' }}>
                                {formError}
                            </div>
                        )}
                    </>
                )}
            </form>
        </>
    )
}
export default PatientDetails
